import React from 'react';

export default () => <div>Trend will be available as current period progresses</div>;



// WEBPACK FOOTER //
// ./src/javascripts/account/usage/committed/EmptyChartPlaceholder.es6.js